import { IonCard, IonList, IonItem, IonAvatar, IonLabel } from "@ionic/react";

// The sidebar's business / user card, as stock Ionic pieces (the whodat
// "business-employee-card"): an IonCard holding an IonList of tappable
// IonItems with the native ripple and detail chevron. Each row shows a
// ui-avatars initial (or a real photo), a muted kicker line and the name;
// the user row can carry an online/offline status dot on its avatar.
//
// rows: [{ kicker, name, src?, status?: "online" | "offline", onClick? }]
export function uiAvatar(name) {
  return `https://ui-avatars.com/api/?format=svg&background=f4f5f8&color=989aa2&bold=true&length=1&name=${encodeURIComponent(name || "?")}`;
}

export default function SidebarProfileCard({ rows = [] }) {
  return (
    <IonCard className="business-employee-card">
      <IonList>
        {rows.map((r, i) => (
          <IonItem
            key={`${r.kicker}-${i}`}
            lines={i < rows.length - 1 ? "full" : "none"}
            button
            detail
            onClick={r.onClick}
          >
            <IonAvatar slot="start">
              <img alt="" src={r.src || uiAvatar(r.name)} />
              {r.status && <div className={`${r.status} status-circle`} />}
            </IonAvatar>
            <IonLabel>
              <p>{r.kicker}</p>
              {r.name}
            </IonLabel>
          </IonItem>
        ))}
      </IonList>
    </IonCard>
  );
}
